import { Component, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { State } from '@app/state';
import { BaseComponent } from '@components/base.component';
import { CalendarService } from '@app/services/calendar.service';
import { SidebarService } from '@services/sidebar.service';

@Component({
  selector: 'app-calendar-view-subscribers',
  templateUrl: './calendar-view-subscribers.component.html',
  styleUrls: [],
  providers: [SidebarService]
})
@Injectable()
export class CalendarViewSubscribersComponent extends BaseComponent {

  public calendar: {
    name: string,
    uuid: string,
    created_by_user: any,
    created_user: any,
    created_at: string,
    subscriber_count: number,
    subscribers_with_attributes: any
  };
  public dataLoaded = false;

  constructor(
    public activatedRoute: ActivatedRoute,
    public contactGroupService: CalendarService,
    public sidebarService: SidebarService,
    public state: State,
    public router: Router
  ) {
    super();
    this.setObjects({
      route: activatedRoute,
      sidebarService,
      state,
      router,
      modelService: contactGroupService
    });
    this.setPageVars({
      sidebar: ''
    });
    this.modelServiceGetOne(this.routeParams['id'], 'calendar').then(() => {
      this.dataLoaded = true;
    });
  }

  public closeSlideout() {
    this.state.message({ slideoutHide: true });
  }
}
